import { gql } from 'apollo-angular';

export const SendPublicFirstStepByEmailDocument = gql`
  mutation sendPublicFirstStepByEmail($email: String!, $file: Upload!, $input: StatementFirstInputGraphql!) {
    sendPublicFirstStepByEmail(email: $email, file: $file, input: $input)
  }
`;
